  import apiClient from "../utils/apiClient";
  // // Fetch overall dashboard data
  // export const getOverallDashboardApi = async () => {
  //   const token = sessionStorage.getItem("accessToken");
  //   const response = await apiClient.get("/dashboard/overall/", {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //       Accept: "application/json",
  //     },
  //   });
  //   return response.data.data; // Return the 'data' field from the response
  // };
  export const getOverallDashboardApi = async () => {
  try {
    const token = sessionStorage.getItem("accessToken");

    const response = await apiClient.get("/dashboard/overall/", {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    return response.data.data;
  } catch (error) {
    console.error("Dashboard API error:", error);

    // optional: normalize error before throwing
    throw error.response?.data || error.message;
  }
};
